import Fleet_Minimal from './Fleet_Minimal'
import Fleet_Documents from './Fleet_Documents'

export default {
    Fleet_Minimal,
    Fleet_Documents,
}
